module.exports = __webpack_public_path__ + "static/media/bluemedium.f8d49cf9.svg";